import { store } from '@/store'
import { defineStore } from 'pinia'
import { getEnv, isPro } from '@/utils'
import { resetRouter } from '@/router'
import { safeParseJson } from '@bd/vue3-utils'
import { useDictStore } from './dict'
import { getCookie, removeCookie, setCookie } from '@/utils/cache/cookieStorage'
import { setLs } from '@/utils/cache/localStorage'
import { API_CENTER_INFO } from '@/api/center'
import { usePermissionStore } from './permission'

const TOKEN_KEY = 'token'
const INFO_KEY = 'info'

interface UserState {
  token?: string
  info?: Partial<ApiCenter.InfoRes>
}
export const useUserStore = defineStore({
  id: 'user',
  state: (): UserState => {
    const infoStr = localStorage.getItem(INFO_KEY)
    const info = safeParseJson(infoStr)
    return {
      token: getCookie(TOKEN_KEY),
      // token: 'Bearer debug_only',
      info
      // token: getLs(TOKEN_KEY)
    }
  },
  getters: {
    authorization: state => `Bearer ${state.token}`,
    userId: state => state?.info?.id,
    userName: state => state?.info?.loginName,
    departmentName: state => state?.info?.adminStation?.stationName,
    isLogin: state => !!state?.token,
    isLoadInfo: state => {
      const dictStore = useDictStore()
      const permissionStore = usePermissionStore()
      const _gotInfo = !!state?.info?.id
      const _gotDict = dictStore.word.size > 0
      const _gotPermission = permissionStore.inited
      return _gotInfo && _gotDict && _gotPermission
    }
  },
  actions: {
    setToken(token: string): void {
      this.token = token
      setCookie(TOKEN_KEY, token, {
        expires: +getEnv('VITE_BD_TOKEN_EXPIRES'),
        domain: isPro ? getEnv('VITE_BD_TOKEN_DOMAIN') : undefined
      })
    },
    async setInfo() {
      const info = await API_CENTER_INFO()
      this.info = info
      setLs(INFO_KEY, info)
    },
    /**
     * 登陆后数据获取
     */
    async afterLogin() {
      const dictStore = useDictStore()
      const permissionStore = usePermissionStore()
      await Promise.all([this.setInfo(), dictStore.init(), permissionStore.initPermission()])
    },
    resetState(): void {
      this.token = undefined
      removeCookie(TOKEN_KEY, {
        domain: isPro ? getEnv('VITE_BD_TOKEN_DOMAIN') : undefined
      })
      this.info = undefined
    },
    /**
     * 退出登录
     */
    logout() {
      this.resetState()
      resetRouter()
      const permissionStore = usePermissionStore()
      permissionStore.resetState()
    }
  }
})

// Need to be used outside the setup
export function useUserStoreOutside() {
  return useUserStore(store)
}
